import React from 'react';
import { FadeIn } from './FadeIn';
export function BonusSection() {
  const bonos = [{
    id: '01',
    title: 'Pack Express: 30 Entregables Post-Consulta listos para imprimir',
    value: '$12.000'
  }, {
    id: '02',
    title: 'Banco de Frases Clínicas PRO: 300 formulaciones para historias y evoluciones',
    value: '$10.000'
  }, {
    id: '03',
    title: 'Sistema Anti-Abandono: Desafío de 21 días con trackers semanales',
    value: '$9.000'
  }, {
    id: '04',
    title: 'Kit Primera Consulta Perfecta: Guion 60 min + 8 perfiles + 6 cierres',
    value: '$11.000'
  }, {
    id: '05',
    title: 'Biblioteca de Analogías: 50 explicaciones que el paciente entiende y recuerda',
    value: '$9.000'
  }, {
    id: '06',
    title: 'Kit Menús Rotativos 12x: 12 semanas completas con lista de compras y swap list',
    value: '$12.000'
  }];
  return <section className="py-12 px-4 max-w-5xl mx-auto" data-id="element-28">
      <FadeIn data-id="element-29">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-10 flex items-center justify-center gap-3" data-id="element-30">
          <span className="text-4xl" data-id="element-31">🎁</span> LOS 6 BONOS — SIEMPRE INCLUIDOS
        </h2>
      </FadeIn>

      <FadeIn delay={0.2} data-id="element-32">
        <div className="overflow-x-auto rounded-xl border border-gray-800 bg-gray-900/50" data-id="element-33">
          <table className="w-full text-left border-collapse" data-id="element-34">
            <thead data-id="element-35">
              <tr className="bg-gray-800/80 border-b border-gray-700" data-id="element-36">
                <th className="p-4 font-bold text-gray-400 w-16 text-center" data-id="element-37">
                  #
                </th>
                <th className="p-4 font-bold text-gray-200" data-id="element-38">Bono</th>
                <th className="p-4 font-bold text-gray-400 text-right" data-id="element-39">
                  Valor
                </th>
              </tr>
            </thead>
            <tbody data-id="element-40">
              {bonos.map((bono, index) => <tr key={index} className="border-b border-gray-800/50 hover:bg-gray-800/30 transition-colors" data-id="element-41">
                  <td className="p-4 text-center font-mono text-green-500 font-bold" data-id="element-42">
                    {bono.id}
                  </td>
                  <td className="p-4 text-gray-200 font-medium" data-id="element-43">
                    {bono.title}
                  </td>
                  <td className="p-4 text-right" data-id="element-44">
                    <div className="flex flex-col items-end" data-id="element-45">
                      <span className="text-red-400 line-through text-sm" data-id="element-46">
                        {bono.value}
                      </span>
                      <span className="text-green-400 font-black" data-id="element-47">GRATIS</span>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <div className="mt-8 text-center bg-green-900/20 border border-green-500/30 rounded-xl p-6" data-id="element-48">
          <p className="text-2xl font-bold" data-id="element-49">
            Valor total bonos:{' '}
            <span className="text-red-400 line-through mx-2" data-id="element-50">$63.000</span>
            <span className="text-green-400" data-id="element-51">→ GRATIS con tu Megapack</span>
          </p>
        </div>
      </FadeIn>
    </section>;
}